var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.4502 18.6816H6.24121C6.37305 18.6816 6.46094 18.5938 6.46094 18.4619V13.3643C6.46094 9.21582 9.61621 6.52637 14.1162 6.52637C18.6162 6.52637 21.7715 9.21582 21.7715 13.3643V18.4619C21.7715 18.5938 21.8594 18.6816 21.9912 18.6816H22.7822C23.1689 18.6816 23.459 18.4355 23.459 18.0664V12.96C23.459 8.12598 19.6182 4.86523 14.4326 4.86523H13.7998C8.61426 4.86523 4.77344 8.12598 4.77344 12.96V18.0664C4.77344 18.4355 5.06348 18.6816 5.4502 18.6816ZM8.31543 22.0742H9.36133C10.416 22.0742 11.04 21.4941 11.04 20.4922V16.4756C11.04 15.4736 10.416 14.8936 9.36133 14.8936H8.31543C7.72656 14.8936 7.39258 15.2188 7.39258 15.79V21.1777C7.39258 21.749 7.72656 22.0742 8.31543 22.0742ZM18.8799 22.0742H19.9258C20.5146 22.0742 20.8574 21.749 20.8574 21.1777V15.79C20.8574 15.21 20.5146 14.8936 19.9258 14.8936H18.8799C17.8252 14.8936 17.2012 15.4736 17.2012 16.4756V20.4922C17.2012 21.4941 17.8252 22.0742 18.8799 22.0742Z",
    fill: "#1C1C1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.6ee1714c1c737214bba2a8b58900562c.svg";
export { ForwardRef as ReactComponent };